import { render } from "./UpcomingLecture.vue?vue&type=template&id=47430b68&scoped=true"
import script from "./UpcomingLecture.vue?vue&type=script&lang=js"
export * from "./UpcomingLecture.vue?vue&type=script&lang=js"

import "./UpcomingLecture.vue?vue&type=style&index=0&id=47430b68&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47430b68"]])

export default __exports__